

//
// Timeline
//

(function($) { "use strict";

	var winWidth = $(window).width();

	if(winWidth >= 1001) {
	

		var container = $('.section-timeline');
		
		// check page contains element
		if( container.length ) {
			
			gsap.registerPlugin(ScrollTrigger);

			let sections = gsap.utils.toArray(".panels_wrap .panel");

			let scrollTween = gsap.to(".panels_wrap", {
				xPercent: -100,
				x: () => window.innerWidth,
				ease: "none",
				scrollTrigger: {
					trigger: ".panels_wrap",
					start: "top top",
					// end: () => "+=" + extraLongContainer.offsetWidth + "px",
					end: "+=3500",
					scrub: true,
					// snap: 1 / (sections.length - 1),
					pin: true,
					invalidateOnRefresh: true,
					anticipatePin: 1,
					// markers: true,
				}	
			});


			ScrollTrigger.create({
				trigger: ".section-timeline",
				toggleClass: {targets: "body", className: "timeline-activated"},
				start: "top 100px",
				// end: "left 50%",
				// markers: true,
			});


			$('.section-timeline .panel').not(':last').each(function(index) {
				console.log('adding timeline panel', (index + 1));
				$(this).addClass('panel-' + (index + 1));
				ScrollTrigger.create({
					trigger: ".panel-" + (index + 1),
					toggleClass: {targets: "body", className: "step-" + (index + 1)},

					start: "left -150px",
					end: "right -151px",
					// markers: true,
					containerAnimation: scrollTween,
				});
			});


			// ScrollTrigger.create({
			// 	trigger: ".panel-1",
			// 	toggleClass: {targets: "body", className: "step-1"},
			// 	start: "left -150px",
			// 	end: "right -151px",
			// 	// markers: true,
			// 	containerAnimation: scrollTween,
			// });
			//
			//
			// ScrollTrigger.create({
			// 	trigger: ".panel-2",
			// 	toggleClass: {targets: "body", className: "step-2"},
			// 	start: "left -150px",
			// 	end: "right -151px",
			// 	// markers: true,
			// 	containerAnimation: scrollTween,
			// });
			//
			// ScrollTrigger.create({
			// 	trigger: ".panel-3",
			// 	toggleClass: {targets: "body", className: "step-3"},
			// 	start: "left -150px",
			// 	end: "right -150px",
			// 	// markers: true,
			// 	containerAnimation: scrollTween,
			// });

			// ScrollTrigger.create({
			// 	trigger: ".panel-4",
			// 	toggleClass: {targets: "body", className: "step-4"},
			// 	start: "left 100px",
			// 	// end: "right -1px",
			// 	// markers: true,
			// 	containerAnimation: scrollTween,
			// });

			ScrollTrigger.create({
				trigger: ".section-timeline",
				toggleClass: {targets: "body", className: "timeline-complete"},
				start: "100.05% bottom",
				// end: "left 50%",
				// markers: true,
			});
	
		}

	}

	

})(jQuery);









// let sections = gsap.utils.toArray(".panel");

// gsap.to(sections, {
//   xPercent: -100 * (sections.length - 1),
//   ease: "none",
//   scrollTrigger: {
// 	trigger: container,
// 	// toggleClass: {targets: "body", className: "activeXXXXX"},
// 	pin: true,
// 	scrub: 1,
// 	// snap: 1 / (sections.length - 1),
// 	// base vertical scrolling on how wide the container is so it feels more natural.
// 	end: "+=3500",
// 	// markers: true,
//   }
// });